import React from 'react'

import RevealUsageCustomer from 'features/reveal/components/RevealUsageCustomer'
import { UrlProvider } from 'urls'

import Table from 'components/table/Table'

import EnrichApiUsageQuota from '../components/EnrichApiUsageQuota'
import { useEnrichCustomersUsage } from '../hooks/useEnrichCustomersUsage'

const config = [
  {
    title: 'Customer ID',
    field: 'customerId',
    headerStyle: { width: '150px' },
  },
  {
    title: 'Customer Name',
    render: RevealUsageCustomer,
  },
  {
    title: 'Quota',
    render: EnrichApiUsageQuota,
  },
  {
    title: 'Created At',
    field: 'createdAt',
  },
]

const EnrichApiUsageOverview = () => {
  const { data, isLoading } = useEnrichCustomersUsage()

  return (
    <Table
      config={config}
      data={data || []}
      getRowLink={({ customerId }) => UrlProvider.getUrl('customer', { id: customerId, tab: '' })}
      hover
      loading={isLoading}
      title="Enrich API Usage"
    />
  )
}

export default EnrichApiUsageOverview
